<template>
  <form v-if="formSearch">
    <div class="md-layout form-search">
      <div
        class="md-layout-item md-small-size-50 md-xsmall-size-100 my-4"
        v-for="sitem in formSearch"
        :key="sitem.name"
        :class="setWidthColumn(sitem.width)"
      >
        <md-datepicker
          v-if="sitem.type === 'date'"
          v-model="sitem.value"
          md-immediately
          :md-model-type="sitem.modelType"
        >
          <label>{{ $t(sitem.label) }}</label>
        </md-datepicker>

        <date-picker-custom
          v-else-if="sitem.type === 'date-picker'"
          :label="$t('common.date')"
          v-model="sitem.value"
        ></date-picker-custom>

        <date-time-picker
          v-else-if="sitem.type === 'date-time'"
          :label="$t('common.date_time')"
          v-model="sitem.value"
        ></date-time-picker>

        <date-range-picker
          v-else-if="sitem.type === 'date-range'"
          :label="$t(sitem.label)"
          v-model="sitem.value"
        ></date-range-picker>

        <checkbox-multi-select
          v-else-if="sitem.type === 'checkbox-multi-select'"
          v-model="sitem.value"
          :label="sitem.label"
          :options="sitem.options"
          :trackBy="sitem.trackBy"
          :placeholder="sitem.placeholder"
          @filtering="sitem.filtering($event.text)"
          :displayField="sitem.displayField"
          :values.sync="sitem.value"
          :style="{ marginTop: '-5px' }"
          :showSelectAll="sitem.showSelectAll"
        ></checkbox-multi-select>

        <md-field v-else-if="sitem.type === 'select'" maxlength="255">
          <label
            :class="isEmptyValue(sitem) ? 'select-label' : ''"
            :for="sitem.name"
            >{{ $t(sitem.label) }}</label
          >
          <md-select
            v-model="sitem.value"
            :name="sitem.name"
            :id="sitem.name"
            :multiple="sitem.multiple"
            @md-selected="
              $event => {
                sitem.onSelected && sitem.onSelected($event);
              }
            "
            maxlength="255"
          >
            <!-- <md-option :value="''">--- All --</md-option> -->
            <md-option
              v-for="(option, idx) in sitem.options"
              :value="option[sitem.trackBy || 'id']"
              :key="sitem.name + option.name + idx + option.id"
              maxlength="255"
              >{{
                sitem.is_switch_locale === "false" &&
                option.name !== "common.all"
                  ? option[sitem.displayField || "name"]
                  : $t(option[sitem.displayField || "name"])
              }}
            </md-option>
          </md-select>
        </md-field>

        <isis-autocomplete
          v-else-if="sitem.type === 'autocomplete'"
          v-model="sitem.displayValue"
          :value.sync="sitem.value"
          :options.sync="sitem.options"
          :refetchOptions="sitem.refetchOptions"
          :search-key="sitem.searchKey"
          :fields="sitem.fields"
          :label="sitem.label"
          :isDisabled="sitem.isDisabled"
        >
        </isis-autocomplete>
        <md-field v-else>
          <label>{{ $t(sitem.label) }}</label>
          <md-input
            v-model.trim="sitem.value"
            :data-vv-name="sitem.name"
            :type="sitem.type"
            @keydown.enter.prevent="search"
          >
          </md-input>
        </md-field>
      </div>
      <div class="md-layout-item text-center" :class="getClassSearchAction()">
        <slot name="search-actions" :actions="{ search }">
          <md-card-actions
            class="text-center md-layout-item mx-0"
            style="justifyContent: center"
          >
            <md-button
              native-type="submit"
              @click.native.prevent="search"
              class="md-info md-round"
              >{{ $t("common.search") }}
            </md-button>

            <md-button
              @click.native.prevent="exportCSV"
              class="md-warning md-round"
              v-if="enableExport"
              >{{ $t("common.export") }}
            </md-button>
          </md-card-actions>
        </slot>
      </div>
    </div>
  </form>
</template>

<script>
import queryHelper from "@/helpers/query-helper";
// import TagMultiSelect from "./TagMultiSelect";
import CheckboxMultiSelect from "./CheckboxMultiSelect";
import _ from "lodash";

export default {
  name: "YvFormSearch",
  components: { CheckboxMultiSelect },
  props: ["formSearch", "enableExport", "inlineSearchAction"],
  data() {
    return {
      autoPath: "/"
    };
  },
  created() {
    let params = queryHelper.buildQuery(this.formSearch);
    this.$emit("initialize-params", params);
  },
  methods: {
    search() {
      let params = queryHelper.buildQuery(this.formSearch);
      this.$emit("search", params);
    },
    exportCSV() {
      let params = queryHelper.buildQuery(this.formSearch);
      this.$emit("export", params);
    },
    getOptions: _.debounce(function(term, item) {
      const queryObj = queryHelper.buildQuery([
        {
          name: item.getOptBy,
          value: term
        }
      ]);

      item.getOptions(queryObj).then(() => {
        item.value = "";
      });
    }, 500),
    displayOptValue(opt, optFieldToDisplay) {
      return optFieldToDisplay ? opt[optFieldToDisplay] : opt;
    },
    selectOption(opt, sitem) {
      const selectedValue = sitem.selectOption ? sitem.selectOption(opt) : opt;
      sitem.value = selectedValue;
      sitem.displayValue = opt[sitem.optFieldToDisplay];
    },
    changeSearchTxt(term, sitem) {
      // clear selected value when click clear query
      if (!term && sitem.value) {
        sitem.value = "";
        this.getOptions(term, sitem);
        return;
      }

      // prevent call getOption when select
      if (term && term === sitem.displayValue) return;

      // if query !== selected => clear & input new

      sitem.value = "";
      sitem.displayValue = "";

      this.getOptions(term, sitem);
    },
    getClassSearchAction() {
      return this.inlineSearchAction
        ? "md-large-size-auto md-small-size-50 md-xsmall-size-100"
        : "md-size-100";
    },
    isEmptyValue(sitem) {
      // first option has name but value == ""
      // FIX-ME: If you display with another key, please replace checking name
      return !sitem.value && sitem.options[0] && sitem.options[0].name;
    },
    setWidthColumn(width) {
      return width ? `md-size-${width}` : "md-size-20";
    },

    getQueryParams() {
      return queryHelper.buildQuery(this.formSearch);
    }
  },
  computed: {},
  watch: {
    formSearch: {
      deep: true,
      handler: function() {
        let params = queryHelper.buildQuery(this.formSearch);
        this.$emit("update-params", params);
      }
    }
  }
};
</script>

<style lang="scss">
.md-card .md-card-actions {
  border: none;
}

.form-search {
  // justify-content: space-between;
  .md-layout-item {
    margin-bottom: 0 !important;
    margin-top: 0 !important;
  }

  .md-field {
    //margin-top: 19px;
    margin-bottom: 10px !important;

    label {
      top: unset;
      bottom: 16px !important;
    }

    .highup-label {
      top: unset;
      bottom: 36px !important;
      font-size: 14px;
    }

    &.md-focused {
      label {
        @extend .highup-label;
        font-weight: 400;
      }
    }

    &.md-has-value {
      label {
        @extend .highup-label;
      }
    }

    .select-label {
      @extend .highup-label;
    }
  }
}

//multiple select
@media screen and (max-width: 640px) {
  .e-popup-open {
    top: 55px !important;
    z-index: 100;
  }
}
</style>
